require('./bootstrap');

import $ from 'jquery';

window.$ = window.jQuery = $;

import 'jquery-datetimepicker';

const tinymce = require("tinymce");

//GLOBALS

let tinySettings = {
    selector: '.richText',
    height: 300,
    width: '100%',
    plugins: 'code link image',
    content_css: '/css/app.css',
    entity_encoding: 'raw',
    relative_urls: false,
    remove_script_host: false,
    link_class_list: [
        {title: 'None', value: ''},
        {title: 'Button', value: 'btn btn-save'},
    ]
};

$(document).ready(function () {
    jQuery.datetimepicker.setLocale('de');
    jQuery('.datepicker').datetimepicker({
        timepicker: false,
        format: 'Y-m-d'
    });
    $('.removeProgram').click(function () {
        $('#programNo' + $(this).data('loop')).remove();
    });
    $('.removeStream').click(function () {
        $('#streamNo' + $(this).data('loop')).remove();
    });

    tinymce.init(tinySettings);
    initDateTimePicker();

    let questionWindow = $('#questionWindow');

    $('#addProgram').click(function (e) {
        e.preventDefault()
        let newIndex = parseNewRow($('#newProgramIndex'), $('#programTemplate'), $('#programRows'));
        initRemoveProgram(newIndex);
    });

    $('#addStream').click(function (e) {
        e.preventDefault()
        let newIndex = parseNewRow($('#newStreamIndex'), $('#streamTemplate'), $('#streamRows'));
        initRemoveStream(newIndex);
    });

    function parseNewRow(newIndex, template, table) {
        let generatedIndex = parseInt(newIndex.val());
        let html = template.html();
        html = html.replace(/###loopIteration###/g, generatedIndex);
        html = html.replace(/<table>/g, '');
        html = html.replace(/<tbody>/g, '');
        html = html.replace(/<\/tbody>/g, '');
        html = html.replace(/<\/table>/g, '');
        table.append(html);
        newIndex.val(generatedIndex + 1);
        initDateTimePicker();

        return generatedIndex;
    }

    function initDateTimePicker() {
        jQuery('.datetimepicker').datetimepicker({
            timepicker: true,
            format: 'Y-m-d H:i',
            step: 15
        });
    }

    function initRemoveProgram(index) {
        $('#removeProgram' + index).click(function () {
            $('#programNo' + index).remove();
        });
    }

    function initRemoveStream(index) {
        $('#removeStream' + index).click(function () {
            $('#streamNo' + index).remove();
        });
    }

    $('#questionOpen').click(function () {
        questionWindow.show();
    });
    $('#questionClose').click(function () {
        questionWindow.hide();
        questionWindow.find('iframe').attr( 'src', function ( i, val ) { return val; });
    });
});
